import Prelogin from "../services/preLoginApi";
let api = new Prelogin();

export const getFundsCategorisation = async () => {
  try {
    let payloadForFunds = {
      api_name: "FundCategoryNew",
      categoryType: "MF",
    };
    let categoryNewRes = await api.getFundsCategorisation(payloadForFunds);
    console.log('CATEEGGORY', categoryNewRes)
    if (categoryNewRes.data.success) {
      return categoryNewRes.data.data;
    }
    return [];
  } catch (e) {
    console.error(e)
    throw new Error("Failed to fetch fund categorisation.");
  }
};
